import './style.css';

import createReactClass from 'create-react-class';
import _ from 'lodash';
import { observer } from 'mobx-react';
import React from 'react';
import PublishMixin from '../../../mixins/publish-mixin';
import Button from '../../general/button';

let chkval = null;

export default createReactClass({
  displayName: 'ButtonGroup',
  mixins: [PublishMixin],

  getDefaultProps: function () {
    return {
      src: [],
      lookups: {},
      display: 'group', //group, list
      mode: 'single', //append, single, multi
      separator: '\n',
      option: null,
      hasError: false,
      onSet: function () {}
    };
  },

  getInitialState: function () {
    return {
      name: _.uniqueId('radio_')
    };
  },

  shouldComponentUpdate(props) {
    if (this.props.src !== props.src) return true;
    if (this.props.value !== props.value) return true;
    if (this.props.readOnly !== props.readOnly) return true;
    if (!!this.props.valueLink && this.props.valueLink.value !== props.valueLink.value) return true;
    return false;
  },

  onClick: function (v, e) {
    if (this.props.readOnly) return;
    e.preventDefault();
    let val = this.get();
    let toSet = val != null ? val + this.props.separator + v : v;
    this.publish(toSet);
    if (this.props.onSet != undefined) this.props.onSet(e);
  },

  onChange: function (e) {
    if (this.props.readOnly) return;
    e.stopPropagation();
    let val = this.get();
    let toSet = e.target.value;
    if (this.props.mode === 'multi') {
      toSet = _.includes(val, e.target.value)
        ? _.without(val, e.target.value)
        : _.union(val, [e.target.value]);
    }

    this.publish(toSet);
  },

  checked: function (value) {
    if (value.toString) {
      value = value.toString();
    }
    chkval = this.get();

    return chkval != null
      ? chkval.toString() === value || (chkval instanceof Array && _.includes(chkval, value))
      : false;
  },

  render() {
    let that = this;
    let props = _.clone(this.props);
    let src = props.src;

    if (src === null) return <span>No Items Available</span>;

    let displayName = this.props.displayName || this.props.buttontext || 'text'; //depreciating buttontext
    let className = 'bz-button-' + props.display;
    let gridStyle;
    let isObject = src.length > 0 && _.isObject(src[0]) && !_.isDate(src[0]);
    props.hasError = true;

    let style = _.extend({}, props.style, props.errorStyle);

    //This is a datasource to bind to
    if (_.isString(src)) src = this.props.lookups[src] || [];

    //Grid optomisation
    if (this.props.display == 'grid' && this.props.src.length > 0) {
      let lengths = src.map((x) => {
        return (isObject ? x[displayName] : x).length;
      });

      let h = 32;
      let w = _.max(lengths) * 10 + 14;
      let n = this.props.src.length;
      let x = Math.sqrt(w * n * h);

      let min = null;
      let trunc = window.innerWidth - (this.props.margin || 0);
      let lim = 0;

      if (trunc < x) {
        lim = [Math.floor(trunc / w), Math.floor(trunc / w)];
      } else {
        lim = [Math.ceil(x / w), Math.floor(x / w)];
      }

      let res = lim.forEach((l, i) => {
        if (l < 1) return;
        let res = { i: i, x: l * w, p: Math.ceil(n / l) * h + l * w };
        if (min == null || min.p > res.p) min = res;
      });

      className += ' col-' + lim[min.i];
      gridStyle = {
        minWidth: min.x,
        maxWidth: min.x
      };
    }

    let buttons = src.map(function (button, idx) {
      button = {
        text: isObject ? button[displayName] : button,
        value: button.value != null ? button.value : button
      };

      switch (props.mode) {
        case 'append':
          style.width = '100%';
          return (
            <div key={idx}>
              <Button
                style={style}
                className="component"
                disabled={props.disabled}
                onClick={that.onClick.bind(that, button.value)}
              >
                {button.text}
              </Button>
            </div>
          );
        case 'single':
          return (
            <div key={idx}>
              <label>
                <input
                  type="radio"
                  name={that.state.name}
                  value={button.value}
                  disabled={props.disabled}
                  checked={that.checked(button.value)}
                  onChange={that.onChange}
                />
                <span style={style} className="component">
                  {button.text}
                </span>
              </label>
            </div>
          );
        case 'multi':
          return (
            <div key={idx}>
              <label>
                <input
                  type="checkbox"
                  value={button.value}
                  disabled={props.disabled}
                  checked={that.checked(button.value)}
                  onChange={that.onChange}
                />
                <span style={style} className="component">
                  {button.text}
                </span>
              </label>
            </div>
          );
      }
    });

    if (!!this.props.label) label = <div className="button-label">{this.props.label}</div>;
    return (
      <div className={className} style={gridStyle}>
        <div>{buttons}</div>
      </div>
    );
  }
});
